export function loadSquarePaymentsScript(isProduction = process.env.NODE_ENV === 'production') {
	if (window.Square) return Promise.resolve()

	const existing = document.getElementById('square-web-payments-sdk')
	if (existing) {
		return new Promise((resolve, reject) => {
			existing.addEventListener('load', () => resolve())
			existing.addEventListener('error', () => reject(new Error('Failed to load Square Web Payments SDK.')))
		})
	}

	return new Promise((resolve, reject) => {
		const script = document.createElement('script')
		script.id = 'square-web-payments-sdk'
		script.src = isProduction
			? 'https://web.squarecdn.com/v1/square.js'
			: 'https://sandbox.web.squarecdn.com/v1/square.js'
		script.async = true
		script.onload = () => resolve()
		script.onerror = () => reject(new Error('Failed to load Square Web Payments SDK.'))
		document.body.appendChild(script)
	})
}

export async function attachSquareCard(applicationId, locationId, containerSelector) {
	await loadSquarePaymentsScript()
	if (!window.Square?.payments) {
		throw new Error('Square Web Payments SDK is not loaded.')
	}

	const payments = window.Square.payments(applicationId, locationId)
	const card = await payments.card()
	await card.attach(containerSelector)
	return { payments, card }
}

export async function tokenizeSquareCard(card) {
	const result = await card.tokenize()
	if (result.status === 'OK') return result.token
	const message = result.errors?.[0]?.message || 'Card tokenization failed.'
	throw new Error(message)
}
